import SignIn from "./pages/auth/sign-in";
import SignUp from "./pages/auth/sign-up";
import Home from "./pages/public/home";
import About from "./pages/public/about";
import Service from "./pages/public/service";
import Contact from "./pages/public/contact";
import OTP from "./pages/auth/otp";
import CompanyDashboard from "./pages/company/dashboard";
import CompanyProfile from "./pages/company/profile";
import { IoBookmark, IoPerson, IoWallet } from "react-icons/io5";
import CompanyWallet from "./pages/company/wallet";
import CompanySlot from "./pages/company/slot";
import { SlCalender } from "react-icons/sl";
import { FaCodePullRequest } from "react-icons/fa6";
import CurrentRequest from "./pages/company/current-request";
import YourBooking from "./pages/company/your-booking";
import StaticPages from "./pages/public/StaticPages";

const iconClass = "size-6";

const routes = [
  {
    title: "auth",
    layout: "auth",
    pages: [
      {
        name: "sign.in",
        path: "/sign-in",
        element: <SignIn />,
        subPages: [],
      },
      {
        name: "sign.up",
        path: "/sign-up",
        element: <SignUp />,
        subPages: [],
      },
      {
        name: "otp",
        path: "/verify-account",
        element: <OTP />,
        subPages: [],
      },
    ],
  },
  {
    title: "public",
    layout: "public",
    pages: [
      {
        name: "home",
        path: "/",
        element: <Home />,
        subPages: [],
      },
      {
        name: "about.us",
        path: "/about",
        element: <About />,
        subPages: [],
      },
      {
        name: "service",
        path: "/service",
        element: <Service />,
        subPages: [],
      },
      {
        name: "contact",
        path: "/contact",
        element: <Contact />,
        subPages: [],
      },
      {
        name: "static-pages",
        path: "static-pages/:slug",
        element: <StaticPages />,
        subPages: [],
      },
    ],
  },
  {
    title: "company",
    layout: "company",
    pages: [
      // {
      //   name: "dashboard",
      //   path: "/",
      //   element: <CompanyDashboard />,
      //   icon: <MdSpaceDashboard className={iconClass} />,
      //   subPages: [],
      // },
      {
        name: "profile",
        // path: "/profile",
        path: "/",
        element: <CompanyProfile />,
        icon: <IoPerson className={iconClass} />,
        subPages: [],
      },
      {
        name: "slot",
        path: "/slot",
        element: <CompanySlot />,
        icon: <SlCalender className={iconClass} />,
        subPages: [],
      },
      {
        name: "wallet",
        path: "/wallet",
        element: <CompanyWallet />,
        icon: <IoWallet className={iconClass} />,
        subPages: [],
      },
      {
        name: "current.request",
        path: "/current-request",
        element: <CurrentRequest />,
        icon: <FaCodePullRequest className="size-5" />,
        subPages: [],
      },
      {
        name: "booking",
        path: "/your-booking",
        element: <YourBooking />,
        icon: <IoBookmark className={iconClass} />,
        subPages: [],
      },
    ],
  },
];

export default routes;
